/**
 * @packageDocumentation
 * @module HackerAPI.Claim.FieldAnswer
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import { parseDate } from "../../utils/utils";
/**
 * An answer to a field
 * @class
 * @extends { HackerAPI.Base }
 */
var FieldAnswer = /** @class */ (function (_super) {
    __extends(FieldAnswer, _super);
    /**
     * Creates a field answer instance
     * @constructor
     * @param
     */
    function FieldAnswer(_a) {
        var _b = _a === void 0 ? {} : _a, field_id = _b.field_id, fieldId = _b.fieldId, value = _b.value, name = _b.name, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt, type = _b.type, meta = _b.meta;
        var _this = _super.call(this) || this;
        /**
         * The id of the field
         * @type { number }
         */
        _this.fieldId = field_id || fieldId;
        /**
         * The response to the field
         * @type { string | boolean | number | object }
         */
        _this.value = value;
        /**
         * What the field is for
         * @type { string }
         */
        _this.name = name;
        /**
         * The type of field
         * @type { string }
         */
        _this.type = type;
        /**
         * Additional info accompanying a field. This is present on `file` fields.
         * @type { any }
         */
        _this.meta = meta;
        /**
         * When the field answer was created
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * When the field answer was last updated
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    return FieldAnswer;
}(Base));
export default FieldAnswer;
//# sourceMappingURL=field-answer.js.map